import React from 'react'

const FDTemp = () => {
  return (
    <div className='FDTemp'>
      <div className='FDTemp__mainText'>Get £205*</div>
      <div className='FDTemp__bodyText'>
        *£175 cashback into your account + £30 Amazon.co.uk Gift Card
      </div>
      <div className='FDTemp__footerText'>Offer ends 6th March at 23:59</div>
    </div>
  )
}

export default FDTemp
